<template>
  <div
    v-if="message"
    class="chart-data-limit-hint"
  >
    <m-tag
      large
      rounded
      color="light"
    >
      {{ message }}
      <m-tooltip class="_info-icon">
        <m-icon
          type="question-circle"
          :color="$colors.grey.lighten1"
          size="12"
        />
        <template #title>
          {{ $t('gridPageChart.dataLimitTooltip') }}
        </template>
      </m-tooltip>
    </m-tag>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  chartDataResult: {
    type: Object,
    default: null,
  },
});

const { t } = useI18n();

const message = computed(() => {
  const r = props.chartDataResult;
  if (!r?.isTruncated) return null;
  if (r.totalSeriesCount !== undefined && r.shownSeriesCount < r.totalSeriesCount) {
    return t('gridPageChart.dataLimitCategoriesAndSeries', {
      shown: r.shownCount,
      total: r.totalCount,
      shownSeries: r.shownSeriesCount,
      totalSeries: r.totalSeriesCount,
    });
  }
  return t('gridPageChart.dataLimitCategories', { shown: r.shownCount, total: r.totalCount });
});
</script>

<style scoped lang="scss">
.chart-data-limit-hint {
  display: flex;
  justify-content: center;

  ._info-icon {
    margin-left: 0.4rem;
  }
}
</style>
